import { Component, OnInit, AfterContentInit } from '@angular/core';
import { UserRoleService } from 'src/app/services/user-role.service';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import * as Roles from '../../../../data/constants/roles';

@Component({
  selector: 'manage-role',
  templateUrl: './manage-role.component.html',
  styleUrls: ['./manage-role.component.scss']
})
export class ManageRoleComponent implements OnInit, AfterContentInit {
  displayedColumns: string[] = [];
  isCreateAndEdit: boolean;
  listRoles: object[];
  listPermissions: object[];
  modulePermissions: object[];
  roleDataSource = [];
  modueleroleDataSource = [];
  uniqueListRoles = [];
  companyId: number;
  activeIndex = 0;
  columns = [{
    columnDef: 'perm_name', header: 'Permission', columnType: 'text', customClass: ''
  }];
  dataSource: MatTableDataSource<any>;
  moduleDataSource: MatTableDataSource<any>;
  currentlyOpenedItemIndex = -1;


  constructor(private userRoleService: UserRoleService,
    private router: Router, private authenticationService: AuthenticationService,
    private route: ActivatedRoute) {
    this.listRoles = [];
  }

  ngOnInit() {
    this.authenticationService.currentUser.subscribe((data) => {
      if (data) {
        data['permissions'].forEach(el => {
          if (el === 'EDIT_ROLE') {
            this.isCreateAndEdit = true;
          }
        });
      }
    });

    this.dataSource = new MatTableDataSource();

    // if (sessionStorage.getItem('userTypeRole') !== Roles.PLATFORMADMIN) {
    //   this.companyId = parseInt(sessionStorage.getItem('companyId'));
    // } else {
    //   this.companyId = parseInt(sessionStorage.getItem('selectedCompanyId'))
    // }
    this.companyId = parseInt(sessionStorage.getItem('selectedCompanyId'))

    this.userRoleService.getRoleByCompanyId(this.companyId).subscribe(data => {
      if (data) {
        this.listRoles = data;

        data.forEach((uniqueRoles) => {
          if (!this.uniqueListRoles.find(x => x.name === uniqueRoles.name)) {
            this.uniqueListRoles.push(uniqueRoles);
          }
        });

        this.uniqueListRoles.forEach((element: any) => {
          if (element.name !== "" && element.name !== null) {
            this.columns.push({
              columnDef: element.name,
              header: element.name.toUpperCase(),
              columnType: 'check',
              customClass: ''
            });
          }
        });
        this.displayedColumns = this.columns.map(c => c.columnDef);
        this.userRoleService.getPermissions().subscribe(data => {
          this.listPermissions = data['permissionList'];
          this.modulePermissions = data['modulePermissions'];
          this.buildDataSource();
          //this.buildDataSourceModule();
        });
      }
    });
  }

  // onTabOpen(event) {
  //   this.activeIndex = event.index ;
  // }
  ngAfterContentInit() {

  }

  setOpened(itemIndex) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  buildDataSource() {
    this.listPermissions.forEach((v, k) => {
      let rowObj = {
        perm_name: v['name'].toUpperCase()
      }
      this.listRoles.forEach((val, key) => {
        rowObj[val['name']] = false;
        if (val['permissionList']?.length > 0) {
          val['permissionList'].forEach(item => {
            if (item.id == v['id']) {
              rowObj[val['name']] = true;
            }
          })
        } else {
          rowObj[val['name']] = false;
        }
      });
      this.roleDataSource.push(rowObj);
    });
    this.dataSource = new MatTableDataSource(this.roleDataSource);

  }

  buildDataSourceModule(module) {
    let modRoleDataSource = [];
    if (module['permissionList'].length > 0) {
      module['permissionList'].forEach((v, k) => {
        let rowObj = {
          perm_name: v['name'].toUpperCase()
        }
        this.listRoles.forEach((val, key) => {
          rowObj[val['name']] = false;
          if (val['permissionList']?.length > 0) {
            val['permissionList'].forEach(item => {
              if (item.id == v['id']) {
                rowObj[val['name']] = true;
              }
            })
          } else {
            rowObj[val['name']] = false;
          }
        });
        modRoleDataSource.push(rowObj);
      });
      return new MatTableDataSource(modRoleDataSource);
    }

  }

  buildDataSourceModuleOld() {
    let tempArray = []
    this.modulePermissions.forEach((module) => {
      tempArray.push({ "name": module['moduleName'], "permissionList": module['permissionList'] })
    })
    // this.listRoles.forEach((modulePermission) => {
    //   if(modulePermission['modulePermissions']) {
    //     tempArray.findIndex(x => x.name === modulePermission['modulePermissions'][0].moduleName)
    //     modulePermission['modulePermissions'].forEach(element => {
    //       tempArray[tempArray.findIndex(x => x.name === element.moduleName)].permissions = element.permissionList;
    //     });
    //   }

    // })

    tempArray.forEach((module, i) => {
      tempArray[i]['obj'] = []
      module.permissionList.forEach(permission => {
        let obj = { 'perm_name': permission['name'].toUpperCase() }
        this.listRoles.forEach((val, key) => {
          if (val['modulePermissions'] == null) {
            obj[val['name']] = false;
          } else {
            val['modulePermissions'].forEach(element => {
              if (element.moduleName === module.name) {
                if (element['permissionList'].length > 0) {
                  element['permissionList'].forEach(item => {
                    if (item.id == permission['id']) {
                      obj[val['name']] = true;
                    }
                  })
                } else {
                  obj[val['name']] = false;
                }
              }
            });
          }
        });
        tempArray[i]['obj'].push(obj);
      });
    })
    let valD = [];
    tempArray.forEach((e) => { valD.push(e.obj) })
    this.moduleDataSource = new MatTableDataSource(valD);

  }

  createNewRole() {
    localStorage.removeItem('role');
    this.router.navigate(['../createrole'], { relativeTo: this.route });
  }

}


